import { Component, Input, OnInit, ViewChildren, QueryList } from '@angular/core';
import { Payment, Transaction } from '../../models';
import { CopyToClipboardComponent } from 'src/app/shared/components/copy-to-clipboard/copy-to-clipboard.component';
import { TokenServiceService } from '../../services/token-service.service';
import { AVAILABLE_TRANSLATIONS, CURRENCIES } from '../../../assets/strings/translations';

@Component({
  selector: 'app-transfer-instructions',
  templateUrl: './transfer-instructions.component.html',
  styleUrls: ['./transfer-instructions.component.scss']
})
export class TransferInstructionsComponent implements OnInit {

  @Input() transaction: Transaction;
  @Input() info: Payment;
  @Input() currentConcept: any;
  @Input() transferNetworkCode: Number;
  @ViewChildren(CopyToClipboardComponent) copiesComponents: QueryList<CopyToClipboardComponent>;
  currentCountry: string = AVAILABLE_TRANSLATIONS.COL;
  interbankRedCode = 380;

  constructor(private readonly tokenServiceService: TokenServiceService) { }

  ngOnInit() {
    this.setCurrentCountry();
  }

  notCRC() {
    return this.currentCountry != AVAILABLE_TRANSLATIONS.CRC;
  }

  notPER() {
    return this.currentCountry != AVAILABLE_TRANSLATIONS.PER;
  }

  setCurrentCountry() {

    const currency = this.tokenServiceService.getAndDecodeToken().ORDER_CURRENCY;

    switch (currency) {
      case CURRENCIES.COP:
        this.currentCountry = AVAILABLE_TRANSLATIONS.COL;
        break;
      case CURRENCIES.PEN:
        this.currentCountry = AVAILABLE_TRANSLATIONS.PER;
        break;
      case CURRENCIES.USD:
        this.currentCountry = AVAILABLE_TRANSLATIONS.ECU;
        break;
      case CURRENCIES.CRC:
        this.currentCountry = AVAILABLE_TRANSLATIONS.CRC;
        break;
      default:
        this.currentCountry = AVAILABLE_TRANSLATIONS.COL;
        break;
    }
  }

}
